import { For, Show, type JSX } from "solid-js";

import styles from "../deck.module.css";
import { PictureWithMarks } from "../picture_with_marks";
import { photoRef, type PictureSrc, type WhatWeFoundSlide as WhatWeFoundSlideData } from "../types";

/** Today's pictures with Pearl's marks, beside the doctor's few sentences. With no pictures the words take the slide. */
export function WhatWeFoundSlide(props: {
  slide: WhatWeFoundSlideData;
  pictureSrc: PictureSrc;
  failedPictureText?: string;
}): JSX.Element {
  return (
    <>
      <div class={styles["ph-text"]}>
        <h2 class={styles["s-h"]}>{props.slide.headline}</h2>
        <Show when={props.slide.box.length > 0}>
          <div class={styles["box"]}>
            <p class={styles["box-k"]}>{props.slide.boxTitle}</p>
            <ul class={styles["box-s"]}>
              <For each={props.slide.box}>{(sentence) => <li>{sentence}</li>}</For>
            </ul>
          </div>
        </Show>
      </div>
      <Show when={props.slide.pictures.length > 0}>
        <div class={styles["ph-pic"]} data-count={props.slide.pictures.length}>
          <For each={props.slide.pictures}>
            {(picture) => (
              <PictureWithMarks
                picture={picture}
                src={props.pictureSrc(photoRef(picture))}
                failedText={props.failedPictureText}
              />
            )}
          </For>
        </div>
      </Show>
    </>
  );
}
